namespace TabAurous.OMS {
    export interface SubCategoryMasterForm {
        ItemTypeId: Serenity.LookupEditor;
        Details: CommonCategoryLookup;
        SubCategoryCode: Serenity.StringEditor;
        SubCategoryName: Serenity.StringEditor;
        CategoryName: Serenity.StringEditor;
        PointerWeight: WeightEditor;
        IsDisabled: Serenity.BooleanEditor;
    }

    export class SubCategoryMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.SubCategoryMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SubCategoryMasterForm.init)  {
                SubCategoryMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = CommonCategoryLookup;
                var w2 = s.StringEditor;
                var w3 = WeightEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(SubCategoryMasterForm, [
                    'ItemTypeId', w0,
                    'Details', w1,
                    'SubCategoryCode', w2,
                    'SubCategoryName', w2,
                    'CategoryName', w2,
                    'PointerWeight', w3,
                    'IsDisabled', w4
                ]);
            }
        }
    }
}
